module.exports = __webpack_public_path__ + "static/media/Logo-MFPE.97b8802c.png";